export const Footer = () => {
  return (
    <div className="navbar">
      {/* Mobile */}
      <div className="px-5 py-2 bg-yellow-400 flex w-full items-center justify-between sm:hidden">
        <p className="text-sm italic">
          Desarrollado por:{' '}
          <a
            className="underline font-bold"
            href="https://www.zeusagencia.com"
            target="_BLANK"
            rel="noopener noreferrer"
          >
            Zeus Agencia
          </a>
        </p>
        <p className="text-sm italic text-black dark:text-white">
          Versión Aniversario
        </p>
      </div>

      {/* Desktop */}
      <div className="px-5 py-2 bg-yellow-400 hidden sm:flex w-full items-center relative">
        <p className="text-sm italic absolute left-1/2 -translate-x-1/2">
          Desarrollado por:{' '}
          <a
            className="underline font-bold"
            href="https://www.zeusagencia.com"
            target="_BLANK"
            rel="noopener noreferrer"
          >
            Zeus Agencia
          </a>
        </p>
        <p className="text-sm italic text-black dark:text-white ml-auto">
          Versión Aniversario
        </p>
      </div>
    </div>
  );
};